import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=bb2f44f8&scoped=true&"
var script = {}
import style0 from "./banner.vue?vue&type=style&index=0&id=bb2f44f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2f44f8",
  null
  
)

export default component.exports